<template>
    <div v-if="visible">
        <v-dialog
            v-model="dialog"
            persistent
            max-width="600"
        >
            <v-card>
                <v-card-title class="px-3">Create Schedule</v-card-title>
                <v-divider></v-divider>

                <v-container fluid>
                    <v-row>
                        <!-- Product -->
                        <v-col md="12" class="pb-2">
                            <v-combobox
                                v-model="schedule.product"
                                :items="products"
                                item-text="name"
                                item-value="id"
                                label="Product (Optional)"
                                dense
                                return-object
                                @change="productHandle"
                                ></v-combobox>
                        </v-col>

                        <!-- From Date -->
                        <v-col md="6">
                            <v-menu
                                v-model="fromDateModal"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            ><template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="schedule.fromDate"
                                    label="From Date"
                                    append-icon="mdi-calendar"
                                    readonly
                                    v-on="on"
                                    class="mt-0 pt-0"
                                ></v-text-field
                            ></template>
                                <v-date-picker
                                    v-model="schedule.fromDate"
                                    @input="fromDateModal = false"
                                    @click:date="handleDateFilters"
                                    :allowed-dates="allowedDates"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>

                        <!-- To Date -->
                        <v-col md="6">
                            <v-menu
                                v-model="toDateModal"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            ><template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="schedule.toDate"
                                    label="To Date"
                                    append-icon="mdi-calendar"
                                    readonly
                                    v-on="on"
                                    class="mt-0 pt-0"
                                ></v-text-field
                            ></template>
                                <v-date-picker
                                    v-model="schedule.toDate"
                                    @input="toDateModal = false"
                                    @click:date="handleDateFilters"
                                    :allowed-dates="allowedDates"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>

                        <!-- Payment Frequency -->
                        <v-col md="6" class="pt-0">
                            <v-select
                                v-model="schedule.paymentFrequency"
                                :items="paymentFrequencyOptions"
                                dense
                                label="Payment Frequency"
                                @change="schedule.collectionDay = null"
                            ></v-select>
                        </v-col>
            
                        <!-- Collection Day -->
                        <v-col v-if="schedule.paymentFrequency <= 4 || schedule.paymentFrequency == 7 || schedule.paymentFrequency == 8" md="6" class="pt-0">
                            <v-select
                                v-model="schedule.collectionDay"
                                :items="collectionDay"
                                :rules="rules.required"
                                return-object
                                required
                                dense
                                label="Collection Day"></v-select>
                        </v-col>

                        <!-- Amount -->
                        <v-col md="6" class="pt-0 pb-0">
                            <v-text-field
                                v-model="schedule.amount"
                                :rules="rules.required"
                                required
                                dense
                                label="Amount"
                            ></v-text-field>
                        </v-col>

                        <!-- Preview -->
                        <v-col v-if="'payments' in preview" md="12" class="pt-0 pb-0 text-center">
                            <v-card
                                outlined
                                class="pa-2"
                            >
                                {{ preview.payments }} payments x {{ client.crm_config.currency }} {{ preview.amount }} = {{ calcPreview }}

                                <v-card-text>
                                    <div style="overflow-y: scroll; max-height:400px;">
                                        <div v-for="item in preview.executionPlan" :key="item.paymentId">
                                            <span>Payment {{ item.paymentId }}: {{ item.date }}</span>
                                        </div>
                                    </div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>

                    <v-col v-if="success" md="12" class="px-0 pt-4">
                        <v-alert type="success" text border="left" dismissible class="mb-0" dense>
                            <div>Successfully created schedule.</div>
                        </v-alert>
                    </v-col>
                </v-container>


                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" @click="$emit('close', false); success = false;">Close</v-btn>
                    <v-btn color="primary" @click="previewSchedule();">Preview</v-btn>
                    <v-btn color="primary" @click="createSchedule();">Create Schedule</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

export default {
    props: {
        visible: Boolean,
        cardData: Object,
        client: Object,
        channels: Object
    },
    computed: {
        dialog() {
            return this.visible ? true : false;
        },
        collectionDay() {
            if(this.schedule.paymentFrequency == 0) {
                return this.collectionDayOptions;
            }
            else if(this.schedule.paymentFrequency == 1) {
                return this.collectionMonthVariableOptions;
            }
            else if(this.schedule.paymentFrequency == 2 || this.schedule.paymentFrequency == 7 || this.schedule.paymentFrequency == 8) {
                return this.collectionMonthSpecificOptions;
            }
            else {
                return this.collectionDayOptions;
            }
        },
        products() {
            if(typeof this.client !== 'undefined' && this.client.product && this.client.product.length > 0) {
                return this.client.product;
            }
            else {
                return [];
            }
        },
        calcPreview() {
            let amount = this.preview.payments * this.preview.amount;
            return this. client.crm_config.currency + ' ' + amount;
            // return Intl.NumberFormat('en-US', { style: 'currency', currency: 'GBP', minimumFractionDigits: 2 }).format(amount);
        }
    },
    data() {
        return {
            schedule: { fromDate: moment().add('1', 'day').format('YYYY-MM-DD').toString(),
                        toDate: moment().add('1', 'month').format('YYYY-MM-DD').toString(),
                        product: null,
                        paymentFrequency: 0,
                        registrationId: null,
                        registrationUuid: null,
                        holder: null,
                        amount: null,
                        frequency: null,
                        collectionDay: null,
                        collectionDayName: null
            },
            fromDateModal: false,
            toDateModal: false,
            rules: { required: [ v => !!v || 'Required' ],
                     email: [ v => this.emailRule(v) ],
            },
            success: false,
            paymentFrequencyOptions: [{ text: 'Weekly', value: 0 },
                                      { text: 'Monthly - Specific', value: 2 },
                                      { text: 'Monthly - Variable', value: 1 },
                                      //{ text: 'Monthly - First Working Day', value: 5 },
                                      { text: 'Monthly - Last Working Day', value: 6 },
                                      { text: 'Fortnightly', value: 3 },
                                      { text: 'Four Weekly', value: 4 },
                                      { text: 'Quarterly', value: 8 },
                                      { text: 'Annual', value: 7}],
            collectionDayOptions: [{ text: 'Monday', value: 'MON' },
                                   { text: 'Tuesday', value: 'TUE' },
                                   { text: 'Wednesday', value: 'WED' },
                                   { text: 'Thursday', value: 'THU' },
                                   { text: 'Friday', value: 'FRI' },
                                   { text: 'Saturday', value: 'SAT' },
                                   { text: 'Sunday', value: 'SUN' }],
            collectionMonthVariableOptions: [{ text: 'First Monday', value: '2#1' },
                                             { text: 'First Tuesday', value: '3#1' },
                                             { text: 'First Wednesday', value: '4#1' },
                                             { text: 'First Thursday', value: '5#1' },
                                             { text: 'First Friday', value: '6#1' },
                                             { text: 'First Saturday', value: '7#1' },
                                             { text: 'First Sunday', value: '1#1' },
                                             { text: 'Last Monday', value: '2L' },
                                             { text: 'Last Tuesday', value: '3L' },
                                             { text: 'Last Wednesday', value: '4L' },
                                             { text: 'Last Thursday', value: '5L' },
                                             { text: 'Last Friday', value: '6L' },
                                             { text: 'Last Saturday', value: '7L' },
                                             { text: 'Last Sunday', value: '1L' }],
            collectionMonthSpecificOptions: [{ text: '1st', value: 1 },
                                             { text: '2nd', value: 2 },
                                             { text: '3rd', value: 3 },
                                             { text: '4th', value: 4 },
                                             { text: '5th', value: 5 },
                                             { text: '6th', value: 6 },
                                             { text: '7th', value: 7 },
                                             { text: '8th', value: 8 },
                                             { text: '9th', value: 9 },
                                             { text: '10th', value: 10 },
                                             { text: '11th', value: 11 },
                                             { text: '12th', value: 12 },
                                             { text: '13th', value: 13 },
                                             { text: '14th', value: 14 },
                                             { text: '15th', value: 15 },
                                             { text: '16th', value: 16 },
                                             { text: '17th', value: 17 },
                                             { text: '18th', value: 18 },
                                             { text: '19th', value: 19 },
                                             { text: '20th', value: 20 },
                                             { text: '21st', value: 21 },
                                             { text: '22nd', value: 22 },
                                             { text: '23rd', value: 23 },
                                             { text: '24th', value: 24 },
                                             { text: '25th', value: 25 },
                                             { text: '26th', value: 26 },
                                             { text: '27th', value: 27 },
                                             { text: '28th', value: 28 },
                                             { text: '29th', value: 29 },
                                             { text: '30th', value: 30 },
            ],
            preview: {}
        }
    },
    methods: {
        allowedDates: val => val >= moment().add('1', 'day').format('YYYY-MM-DD'),
        handleDateFilters() {
           if(this.schedule.toDate < this.schedule.fromDate) {
               this.search.fromDate = this.search.toDate;
           }
           return this.$emit('search', this.search);
        },
        productHandle(e) {
            console.log(e);
        },
        calcSchedule() {
            let executionPlan = [];
            let executionPlanJson = {};
            let temp = [];

            // Weekly
            if(this.schedule.paymentFrequency == 0) {
                let weeks = moment(moment(this.schedule.toDate)).diff(moment(this.schedule.fromDate), 'weeks');
                this.schedule.frequency = 'Weekly';

                let day = null;
                if(this.schedule.collectionDay.value == 'MON') { day = 1; }
                else if(this.schedule.collectionDay.value == 'TUE') { day = 2; }
                else if(this.schedule.collectionDay.value == 'WED') { day = 3; }
                else if(this.schedule.collectionDay.value == 'THU') { day = 4; }
                else if(this.schedule.collectionDay.value == 'FRI') { day = 5; }
                else if(this.schedule.collectionDay.value == 'SAT') { day = 6; }
                else if(this.schedule.collectionDay.value == 'SUN') { day = 7; }
          
                if(moment(this.schedule.fromDate).isoWeekday() <= day) { 
                    for(let i = 0; i < weeks; i++) {
                        let date = moment(this.schedule.fromDate).isoWeekday(day).add(i, 'week').format('YYYY-MM-DD');
                        executionPlan.push({ paymentId: i+1,
                                             date: date,
                                             amount: this.schedule.amount });
                    }
                }
                else {
                    for(let i = 0; i < weeks; i++) {
                        let date = moment(this.schedule.fromDate).add(1, 'weeks').isoWeekday(day).add(i, 'week').format('YYYY-MM-DD');
                        executionPlan.push({ paymentId: i+1,
                                             date: date,
                                             amount: this.schedule.amount });
                    }
                }
                console.log('Weekly');
            }
            // Monthly - Variable
            else if(this.schedule.paymentFrequency  == 1) {
                let months = moment(moment(this.schedule.toDate)).diff(moment(this.schedule.fromDate), 'months');
                this.schedule.frequency = 'Monthly';

                // First instance of the month
                if(this.schedule.collectionDay.value.includes('#')) {
                    console.log("Start of month");

                    let day = this.schedule.collectionDay.value.charAt(0) - 1;
                    for(let i = 0; i <= months; i++) {                        
                        let date = moment(this.schedule.fromDate).add(i, 'month').startOf('month');
                        date = date.day(date.day() > day ? day + 7 : day).format('YYYY-MM-DD');                        

                        if(date > moment().format('YYYY-MM-DD')) {
                            executionPlan.push({ paymentId: i+1,
                                                 date: date,
                                                 amount: this.schedule.amount });
                        }
                    }
                }
                // Last instance of the month
                else if(this.schedule.collectionDay.value.includes('L')) {

                    console.log("End of month - Variable");

                    const { collectionDay, amount, fromDate, toDate } = this.schedule;
                    
                    // Collection day values, gets the first character at index 0
                    // Monday = 2L, Tuesday = 3L, Wednesday = 4L, Thursday = 5L, Friday = 6L, Saturday = 7L, Sunday = 1L
                    const collectionDayValue = collectionDay.value.charAt(0);

                    // Monday = 1, Tuesday = 2, Wednesday = 3, Thursday = 4, Friday = 5, Saturday = 6, Sunday = 0
                    const dayOfWeek = collectionDayValue - 1;

                    // Start payment ID counter at 1.
                    let counter = 1;

                    for (let i = 0; i <= months; i++) {

                        // Get the start of the current month, as every month has a first of the month, incrementing by 'i' months from the startDate,
                        // and then get the end of that month.
                        let endOfMonth = moment(fromDate).startOf('month').add(i, 'month').endOf('month');
                        
                        // Get the day of the week for the last day of the month 
                        // Monday = 1, Tuesday = 2, Wednesday = 3, Thursday = 4, Friday = 5, Saturday = 6, Sunday = 0
                        let lastDayOfWeek = endOfMonth.day();
                        
                        /*
                        Calculate the offset to get to the last instance of the specified day of the week
                        If the last day of the month is after the target day of the week, subtract the difference
                        If the last day of the month is before the target day of the week, wrap around by subtracting (7 - difference)

                        Example 1:

                        Collection day: Last Friday,
                        last day of the month is the target day of the week,
                        2024-05

                        dayOfWeek = 5
                        lastDayOfWeek = 5 (Friday 31st)

                        offset = 5 - 5 = 0
                        date = 2024-05-31 - 0 = 2024-05-31

                        Example 2:

                        Collection day: Last Friday,
                        last day of the month is before target day of the week,
                        2024-07

                        dayOfWeek = 5
                        lastDayOfWeek = 3 (Wednesday 31st)
                        offset = 7 - (5 - 3) = 5
                        date = 2024-07-31 - 5 = 2024-07-26

                        Example 3:
                        
                        Collection day: Last Friday,
                        last day of the month is after target day of the week,
                        2024-08

                        dayOfWeek = 5
                        lastDayOfWeek = 6 (Saturday 31st)
                        offset = 6 - 5 = 1
                        date = 2024-08-31 - 1 = 2024-08-30
                        */
                        let offset = (lastDayOfWeek >= dayOfWeek) ? lastDayOfWeek - dayOfWeek : 7 - (dayOfWeek - lastDayOfWeek);
                        
                        // Subtract the offset to find the last instance of the specified day of the week
                        let date = endOfMonth.subtract(offset, 'days').format('YYYY-MM-DD');

                        // Only add the date to the execution plan if it is in the future, after the `fromDate` and before the `toDate`
                        if (date > moment().format('YYYY-MM-DD') && date >= fromDate && date <= toDate) {
                            executionPlan.push({
                                paymentId: counter,
                                date: date,
                                amount: amount
                            });

                            counter++;
                        }

                        console.log({'dayOfWeek': dayOfWeek, 'endOfMonth': endOfMonth.format('YYYY-MM-DD'), 'lastDayOfWeek': lastDayOfWeek, 'offset': offset, 'date': date});
                    }
                }
            }
            // Monthly - Specific
            else if(this.schedule.paymentFrequency == 2) {

                // Pull the user-defined information in the `schedule` property into separate variables
                const { collectionDay, amount, fromDate, toDate } = this.schedule;

                // Calculate the difference in months between the `fromDate` and the end of the month of `toDate`
                const endOfMonth = moment(toDate).endOf('month');
                const diffMonths = moment(endOfMonth).diff(fromDate, 'months');

                // Assign the frequency as Monthly in the `schedule` property
                this.schedule.frequency = 'Monthly';

                // Loop through each month within the `fromDate` and `toDate` range
                for(let i = 0; i <= diffMonths; i++) {

                    let scheduleStartDate = fromDate;
                    let collectionDayValue = collectionDay.value;

                    // Get current day of the month
                    let dtCurrentDay = moment().format('DD');

                    // Get current year-month
                    let dtCurrentYearMonth = moment().format('YYYY-MM');

                    // get current year-month-day
                    let dtCurrentYearMonthDay = moment().format('YYYY-MM-DD')

                    // Get day of the month for `fromDate`
                    let dtFromDay = moment(fromDate).format('DD');

                    // Get year-month for `fromDate`
                    let dtFromYearMonth = moment(fromDate).format('YYYY-MM');

                    // Checks if the current day is greater than or equal to the `collectionDayValue` and the `dtFromYearMonth` is the same as the `dtCurrentYearMonth`.
                    // If this is true, it means that the current month's collection date has already passed, so the start date of the schedule is adjusted by adding one month
                    if (dtCurrentDay >= collectionDayValue && dtFromYearMonth == dtCurrentYearMonth) {
                        scheduleStartDate = moment(fromDate).add(1, 'month').format('YYYY-MM-01');
                    }
                    
                    // Checks if the `dtFromDay` is greater than the `collectionDayValue` and the `dtFromYearMonth` is greater than the `dtCurrentYearMonth`.
                    // If this is true, it means that the collection day for the fromDate has not yet passed for a future month, so the start date of the schedule is also adjusted by adding one month
                    else if (dtFromDay > collectionDayValue && dtFromYearMonth > dtCurrentYearMonth) {
                        scheduleStartDate = moment(fromDate).add(1, 'month').format('YYYY-MM-01');
                    }

                    // Checks if the value of `collectionDayValue` is greater than 28, and if the month of the date obtained by adding `i` months to `scheduleStartDate` is equal to 2 (February).
                    if(collectionDayValue > 28 && moment(scheduleStartDate).add(i, 'month').format('M') == 2) {
                        // If both conditions are true, set the value of `collectionDayValue` to 28 as February has a maximum of 28 days (Excluding leap years)
                        collectionDayValue = 28;
                    }

                    // Calculate the date for the next collection by adding `i` months to the scheduleStartDate and setting the day to collectionDayValue
                    let execDate = moment(scheduleStartDate).add(i, 'month').date(collectionDayValue).format('YYYY-MM-DD');

                    // Check if the execution date is past the currrent date and prior to the schedule end date
                    if(execDate > dtCurrentYearMonthDay && execDate <= toDate) {
                        // Add payment to the `executionPlan` array
                        executionPlan.push({
                            paymentId: i+1,
                            date: execDate,
                            amount: amount
                        });
                    }
                }
                console.log("End of month - Specific");
            }
            // Fortnightly
            else if(this.schedule.paymentFrequency == 3) {
                let weeks = moment(moment(this.schedule.toDate)).diff(moment(this.schedule.fromDate), 'weeks');
                this.schedule.frequency = 'Fortnightly';

                let day = null;
                if(this.schedule.collectionDay.value == 'MON') { day = 1; }
                else if(this.schedule.collectionDay.value == 'TUE') { day = 2; }
                else if(this.schedule.collectionDay.value == 'WED') { day = 3; }
                else if(this.schedule.collectionDay.value == 'THU') { day = 4; }
                else if(this.schedule.collectionDay.value == 'FRI') { day = 5; }
                else if(this.schedule.collectionDay.value == 'SAT') { day = 6; }
                else if(this.schedule.collectionDay.value == 'SUN') { day = 7; }
          
                if(moment(this.schedule.fromDate).isoWeekday() <= day) { 
                    for(let i = 0; i < weeks; i++) {
                        let date = moment(this.schedule.fromDate).isoWeekday(day).add(i, 'week').format('YYYY-MM-DD');
                        if(!(i % 2) || i == 0) {
                            executionPlan.push({ paymentId: executionPlan.length + 1,
                                                 date: date,
                                                 amount: this.schedule.amount });
                        }
                    }
                }
                else {
                    for(let i = 0; i < weeks; i++) {
                        let date = moment(this.schedule.fromDate).add(1, 'weeks').isoWeekday(day).add(i, 'week').format('YYYY-MM-DD');
                        if(!(i % 2) || i == 0) {
                            executionPlan.push({ paymentId: executionPlan.length + 1,
                                                 date: date,
                                                 amount: this.schedule.amount });
                        }
                    }
                }
                console.log('Fortnightly');
            }
            // Four Weekly
            else if(this.schedule.paymentFrequency == 4) {
                let weeks = moment(moment(this.schedule.toDate)).diff(moment(this.schedule.fromDate), 'weeks');
                this.schedule.frequency = 'Four Weekly';

                let day = null;
                if(this.schedule.collectionDay.value == 'MON') { day = 1; }
                else if(this.schedule.collectionDay.value == 'TUE') { day = 2; }
                else if(this.schedule.collectionDay.value == 'WED') { day = 3; }
                else if(this.schedule.collectionDay.value == 'THU') { day = 4; }
                else if(this.schedule.collectionDay.value == 'FRI') { day = 5; }
                else if(this.schedule.collectionDay.value == 'SAT') { day = 6; }
                else if(this.schedule.collectionDay.value == 'SUN') { day = 7; }
          
                if(moment(this.schedule.fromDate).isoWeekday() <= day) { 
                    for(let i = 0; i < weeks; i++) {
                        let date = moment(this.schedule.fromDate).isoWeekday(day).add(i, 'week').format('YYYY-MM-DD');
                        if(!(i % 4) || i == 0) {
                            executionPlan.push({ paymentId: executionPlan.length + 1,
                                                 date: date,
                                                 amount: this.schedule.amount });
                        }
                    }
                }
                else {
                    for(let i = 0; i < weeks; i++) {
                        let date = moment(this.schedule.fromDate).add(1, 'weeks').isoWeekday(day).add(i, 'week').format('YYYY-MM-DD');
                        if(!(i % 4) || i == 0) {
                            executionPlan.push({ paymentId: executionPlan.length + 1,
                                                 date: date,
                                                 amount: this.schedule.amount });
                        }
                    }
                }
                console.log('Four Weekly');
            }

            // First Working Day
            else if(this.schedule.paymentFrequency == 5) {
                console.log("First Working Day");

                let months = moment(moment(this.schedule.toDate)).diff(moment(this.schedule.fromDate), 'months');
                this.schedule.frequency = 'Monthly';
                this.schedule.collectionDay = { text: 'First Working Day' };

                for(let i = 0; i <= months; i++) {                    
                    let date = moment(this.schedule.fromDate).add(i, 'month').startOf('month');
                    
                    if(date.month() > moment().month()) {
                        date =  date.day() == 0 ? moment(date).add(1, 'day').format('YYYY-MM-DD') :
                                date.day() == 6 ? moment(date).add(2, 'day').format('YYYY-MM-DD') :
                                moment(date).format('YYYY-MM-DD');

                        // console.log(date);

                        executionPlan.push({ paymentId: i+1,
                                             date: date,
                                             amount: this.schedule.amount });
                    }
                }
            }

            // Last Working Day
            else if(this.schedule.paymentFrequency == 6) {
                console.log("Last Working Day");
                let months = moment(moment(this.schedule.toDate)).diff(moment(this.schedule.fromDate), 'months');
                this.schedule.frequency = 'Monthly';
                this.schedule.collectionDay = { text: 'Last Working Day' };

                for(let i = 0; i <= months; i++) {                        
                    let date = moment(this.schedule.fromDate).add(i, 'month').endOf('month');
                    
                    if(date > moment()) {
                        date =  date.day() == 0 ? moment(date).subtract(2, 'day').format('YYYY-MM-DD') :
                                date.day() == 6 ? moment(date).subtract(1, 'day').format('YYYY-MM-DD') :
                                moment(date).format('YYYY-MM-DD');

                        // console.log(date);

                        executionPlan.push({ paymentId: i+1,
                                             date: date,
                                             amount: this.schedule.amount });
                    }
                }
            }
            // Quarterly - Specific
            else if(this.schedule.paymentFrequency == 8) {
                let months = moment(moment(this.schedule.toDate).endOf('month')).diff(moment(this.schedule.fromDate), 'quarter');
                this.schedule.frequency = 'Quarterly';
                console.log(months);

                for(let i = 0; i <= months; i++) {
                    if(this.schedule.collectionDay.value > 28 && moment(this.schedule.fromDate).add(i, 'month').format('M') == 2) {
                        if(this.schedule.collectionDay.value <= moment().format('DD') && moment(this.schedule.fromDate).format('YYYY-MM') == moment().format('YYYY-MM')) {
                            this.schedule.fromDate = moment(this.schedule.fromDate).add(1, 'month').format('YYYY-MM-DD');
                        }

                        let date = moment().add(i, 'quarter').date(28).format('YYYY-MM-DD');

                        if(date < this.schedule.fromDate) {
                            date = moment(date).add(1, 'month').format('YYYY-MM-DD');
                            this.schedule.fromDate = this.schedule.fromDate = moment(this.schedule.fromDate).add(1, 'month').format('YYYY-MM-DD');
                        }

                        if(date > moment().format('YYYY-MM-DD')) {
                            executionPlan.push({ paymentId: i+1,
                                                 date: date,
                                                 amount: this.schedule.amount });
                        }
                    }
                    else {
                        if(this.schedule.collectionDay.value <= moment().format('DD') && moment(this.schedule.fromDate).format('YYYY-MM') == moment().format('YYYY-MM')) {
                            this.schedule.fromDate = moment(this.schedule.fromDate).add(1, 'month').format('YYYY-MM-DD');
                        }
                        
                        let date = moment(this.schedule.fromDate).add(i, 'quarter').date(this.schedule.collectionDay.value).format('YYYY-MM-DD');
                        
                        if(date < this.schedule.fromDate) {
                            date = moment(date).add(1, 'month').format('YYYY-MM-DD');
                            this.schedule.fromDate = this.schedule.fromDate = moment(this.schedule.fromDate).add(1, 'month').format('YYYY-MM-01');
                        }

                        if(date > moment().format('YYYY-MM-DD') && date <= this.schedule.toDate) {
                            executionPlan.push({ paymentId: i+1,
                                                 date: date,
                                                 amount: this.schedule.amount });
                        }
                    }
                }
                console.log("Quarterly - Specific");
            }
            // Annual - Specific
            else if(this.schedule.paymentFrequency == 7) {
                let years = moment(moment(this.schedule.toDate).endOf('month')).diff(moment(this.schedule.fromDate), 'years');
                this.schedule.frequency = 'Annual';

                for(let i = 0; i <= years; i++) {
                    if(this.schedule.collectionDay.value > 28 && moment(this.schedule.fromDate).format('M') == 2) {
                        // if(this.schedule.collectionDay.value <= moment().format('DD') && moment(this.schedule.fromDate).format('YYYY-MM') >= moment().format('YYYY-MM')) {
                        //     this.schedule.fromDate = moment(this.schedule.fromDate).add(1, 'month').format('YYYY-MM-DD');
                        // }

                        // if(date < this.schedule.fromDate) {
                        //     date = moment(date).add(1, 'month').format('YYYY-MM-DD');
                        //     this.schedule.fromDate = moment(this.schedule.fromDate).add(1, 'month').format('YYYY-MM-01');
                        // }

                        let date = moment().add(i, 'year').date(28).format('YYYY-MM-DD');
                        if(date > moment().format('YYYY-MM-DD')) {
                            executionPlan.push({ paymentId: i+1,
                                                 date: date,
                                                 amount: this.schedule.amount });
                        }
                    }
                    else {
                        // if(this.schedule.collectionDay.value <= moment().format('DD') && moment(this.schedule.fromDate).format('YYYY-MM') >= moment().format('YYYY-MM')) {
                        //     this.schedule.fromDate = moment(this.schedule.fromDate).add(1, 'month').format('YYYY-MM-DD');
                        // }

                        let date = moment(this.schedule.fromDate).add(i, 'year').date(this.schedule.collectionDay.value).format('YYYY-MM-DD');

                        // if(date < this.schedule.fromDate && moment(date).diff(moment(this.schedule.fromDate), 'days') > 1) {
                        //     date = moment(date).add(1, 'month').format('YYYY-MM-DD');
                        //     this.schedule.fromDate = moment(this.schedule.fromDate).add(1, 'month').format('YYYY-MM-01');
                        // }
                        // else if(moment(date).diff(moment(this.schedule.fromDate), 'days') == 1) {
                        //     console.log(moment(date).diff(moment(this.schedule.fromDate), 'days'));
                        //     date = moment(date).add(1, 'year').format('YYYY-MM-DD');
                        // }
                        
                        if(date > moment().format('YYYY-MM-DD') && date <= this.schedule.toDate) {
                            executionPlan.push({ paymentId: i+1,
                                                 date: date,
                                                 amount: this.schedule.amount });
                        }
                    }
                }
                console.log("Annual - Specific");
            }

            this.schedule.collectionDayName = this.schedule.collectionDay.text;
            executionPlan.forEach((v, k) => {
                executionPlanJson[k] = v;
            });

            return executionPlanJson;
        },
        previewSchedule() {
            let executionPlanJson = this.calcSchedule();
            this.preview = {};
            this.preview.payments = Object.keys(executionPlanJson).length;
            this.preview.amount = executionPlanJson[0].amount;
            this.preview.executionPlan = executionPlanJson;

            console.log(this.preview);

        },
        createSchedule() {
            let executionPlanJson = this.calcSchedule();
            console.log(executionPlanJson);

            axios({
                method: 'post',
                url: 'create-schedule',
                data: { client: this.client,
                        schedule: this.schedule,
                        cardData: this.cardData,
                        channels: this.channels,
                        executionPlan: JSON.stringify(executionPlanJson),
                        userId: this.$store.state.user.id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    // console.log(response.data);
                    this.$emit('getSchedules');
                    this.$emit('getProducts');
                    this.$emit('getClientLog');
                    this.schedule.product = null;
                    this.success = true;
                })
                .catch(e => {
                    this.errors.push(e)
            })
        },
    }
}
</script>